import React, { useState } from "react";
import "../styles/faq.css";

import Divider from "./Divider";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      q: "Mennyibe kerül egy autó bérlése naponta?",
      a: "Áraink típustól függően változnak, de mindig kedvező, rejtett költségek nélküli díjakat biztosítunk.",
    },
    {
      q: "Milyen dokumentumok szükségesek az autóbérléshez?",
      a: "Érvényes személyi igazolvány, lakcímkártya és jogosítvány szükséges minden bérléshez. Amennyiben ezeket előre elküldöd, a szerződést előkészítjük, mire érkezel az autóért.",
    },
    {
      q: "Milyen költségekkel kell kalkulálni az autó átvételekor?",
      a: "A kauciót és a bérleti díjat a bérlés kezdetekor kell megfizetni. Amennyiben az autó ugyanabban az állapotban kerül visszaadásra, mint ahogy átvetted, a kaució összege a bérlés végén azonnal visszajár.",
    },
    {
      q: "Tartalmazza-e a bérleti díj az autópálya-matricát?",
      a: "Igen, minden autónk rendelkezik érvényes országos autópálya-matricával.",
    },
    {
      q: "Mi történik, ha késve adom vissza a bérelt autót?",
      a: "Ilyen esetekben mindig rugalmasan állunk az ügyfelekhez, azonban nagyon fontos, hogy késés esetén időben telefonon jelezd felénk, mivel a késés a következő bérlőt is hátráltathatja.",
    },
    {
      q: "Mi történik, ha hosszabbítani szeretnék?",
      a: "Amennyiben a hosszabbítási szándékodat időben jelzed, igyekszünk autót biztosítani számodra, azonban nem minden esetben garantált, hogy a jelenleg használt autót tudod tovább bérelni.",
    },
    {
      q: "Hogyan vehetem át az autót?",
      a: "Az autót kívül-belül tisztán, teli tankkal adjuk át a telephelyünkön, és ugyanilyen állapotban várjuk vissza a bérlés végén.",
    },
    {
      q: "Miért érdemes minket választani Szolnokon autóbérléshez?",
      a: "Megbízható, rendszeresen karbantartott autók, gyors ügyintézés, korrekt árak és barátságos ügyfélszolgálat. Elérhetőség: +36 70 627 65 99, autokolcsonzoszolnok@outlook.com",
    },
  ];

  return (
    <section id="faq" className="faq-section">
      <div className="container">
        <h2 className="faq-title">Gyakori Kérdések</h2>
        <Divider />
        <p className="fleet-lead">
          Összegyűjtöttük a leggyakrabban felmerülő kérdéseket az autóbérléssel
          kapcsolatban, hogy gyorsan és egyszerűen megtaláld a számodra fontos
          információkat. Tudj meg mindent a bérlés menetéről, az árakról, a
          szükséges dokumentumokról és a szolgáltatásainkról, mielőtt
          lefoglalnád a számodra megfelelő autót Szolnokon.
        </p>

        <div className="faq-list">
          {faqs.map((item, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                {item.q}
                <span
                  className={`faq-icon ${openIndex === index ? "open" : ""}`}
                >
                  ▼
                </span>
              </button>

              <div
                className={`faq-answer-wrapper ${
                  openIndex === index ? "open" : ""
                }`}
              >
                <p className="faq-answer">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="fleet-footnote">
          Araink típustól és a bérleti idő hosszától függően változnak, ezen
          felül csak a kilométer túlfutással kell számolnod, ami napi 250 km
          felett 35ft/km.
        </p>
      </div>
    </section>
  );
}
